(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/jackpots/assets/javascripts/fetch-jackpots.js') >= 0) return;  svs.modules.push('/components/numbergames/jackpots/assets/javascripts/fetch-jackpots.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let currencyInMillions;
let productMapping;
let drawgamesApiCaller;
function formatJackpot(jackpot) {
  const formatAmountMillions = amount => {
    const amountMillions = currencyInMillions(amount);
    return amountMillions.replace(',', '.') > 1 ? "".concat(amountMillions, " miljoner") : "".concat(amountMillions, " miljon");
  };
  const productId = jackpot.productId,
    drawNumber = jackpot.drawNumber,
    jackpots = jackpot.jackpots,
    guaranteedJackpots = jackpot.guaranteedJackpots;
  const productName = productMapping.getProductName(productId);
  return guaranteedJackpots.map(_ref => {
    let winset = _ref.winset,
      windiv = _ref.windiv,
      description = _ref.description,
      jackpotAmountSek = _ref.jackpotAmountSek;
    const guaranteedJackpotAmount = jackpotAmountSek;
    const guaranteedJackpotAmountString = "alltid minst ".concat(formatAmountMillions(guaranteedJackpotAmount), " kr");
    const guaranteedJackpotAmountStringShort = "ca ".concat(currencyInMillions(guaranteedJackpotAmount), " milj kr");
    let defaultJackpot = true;
    let jackpotAmount = guaranteedJackpotAmount;
    let jackpotAmountString = guaranteedJackpotAmountString;
    let jackpotAmountStringShort = guaranteedJackpotAmountStringShort;
    const jackpot = jackpots.find(jackpot => jackpot.winset === winset && jackpot.windiv === windiv);
    if (jackpot) {
      defaultJackpot = false;
      description = jackpot.description;
      jackpotAmount = jackpot.jackpotAmount;
      jackpotAmountString = "ca ".concat(formatAmountMillions(jackpotAmount), " kr");
      jackpotAmountStringShort = "ca ".concat(currencyInMillions(jackpotAmount), " milj kr");
    }
    return {
      defaultJackpot,
      productId,
      productName,
      drawNumber,
      winset,
      windiv,
      description,
      guaranteedJackpotAmount,
      guaranteedJackpotAmountString,
      guaranteedJackpotAmountStringShort,
      jackpotAmount,
      jackpotAmountString,
      jackpotAmountStringShort
    };
  });
}
async function fetchJackpotsByProductDraw(draws, fetchData) {
  if (!Array.isArray(draws)) {
    draws = [draws];
  }
  const allProductDrawIds = productMapping.getAllDrawIds();
  const jackpotsToFetch = draws.filter(draw => draw && allProductDrawIds.includes(productMapping.getProductDrawId(draw.productId)) && draw.drawNumber).map(_ref2 => {
    let productId = _ref2.productId,
      drawNumber = _ref2.drawNumber;
    return {
      product: productMapping.getProductDrawId(productId),
      drawNumber
    };
  });
  if (!jackpotsToFetch.length) {
    throw new Error('fetchJackpotsByProductDraw: No valid draws provided to fetchJackpotsByDrawId');
  }
  let response;
  try {
    response = await Promise.all(jackpotsToFetch.map(drawId => fetchData(drawgamesApiCaller.getDrawJackpot, drawId)));
  } catch (error) {
    throw new Error("fetchJackpotsByProductDraw: Failed to fetch jackpot for ".concat(jackpotsToFetch.map(drawId => "".concat(drawId.product, "&").concat(drawId.drawNumber)).join('|'), " ").concat(error));
  }
  try {
    return response.flatMap(_ref3 => {
      let jackpot = _ref3.jackpot;
      return formatJackpot(jackpot);
    });
  } catch (error) {
    throw new Error("fetchJackpotsByProductDraw: Failed to parse response from ".concat(jackpotsToFetch.map(drawId => "".concat(drawId.product, "&").concat(drawId.drawNumber)).join('|'), " ").concat(error));
  }
}
async function fetchJackpots(draws, fetchData) {
  let jackpots;
  try {
    const response = await fetchData(drawgamesApiCaller.getDrawJackpots);
    jackpots = response.jackpots.flatMap(formatJackpot);
  } catch (error) {
    throw new Error("fetchJackpots: Failed to fetch jackpots ".concat(error));
  }
  if (draws) {
    try {
      const productsToFetch = draws.filter(draw => !productMapping.isKeno(draw.productId) && !productMapping.isJoker(draw.productId) && !jackpots.find(jackpot => productMapping.isSameProduct(draw.productId, jackpot.productId))).map(draw => draw.productId);
      const jackpotsToFetch = Array.from(new Set(productsToFetch)).map(productId => {
        const productDraws = draws.filter(draw => productMapping.isSameProduct(draw.productId, productId)).sort((a, b) => a.drawNumber - b.drawNumber);
        return productDraws[0];
      });
      if (jackpotsToFetch.length) {
        const extraJackpots = await fetchJackpotsByProductDraw(jackpotsToFetch, fetchData);
        jackpots = jackpots.concat(extraJackpots);
      }
    } catch (error) {
      throw new Error("fetchJackpots: Failed to fetch extra jackpots by product and draw ".concat(error));
    }
  }
  return jackpots;
}
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  currencyInMillions = trinidadCore.components.require('utils', 'format').api.CurrencyInMillions;
  var _trinidadCore$compone = trinidadCore.components.require('numbergames', 'product-mapping');
  productMapping = _trinidadCore$compone.productMapping;
  drawgamesApiCaller = trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller;
  const getFetchDataFunction = req => async (fetchFunction, fetchParams) => {
    try {
      return await fetchFunction(_objectSpread(_objectSpread({}, fetchParams), {}, {
        req
      }));
    } catch (error) {
      throw new Error("".concat(error.name, ": ").concat(decodeURIComponent(error.message)));
    }
  };
  module.exports = {
    fetchJackpots: async _ref4 => {
      let draws = _ref4.draws,
        req = _ref4.req;
      return await fetchJackpots(draws, getFetchDataFunction(req));
    },
    fetchJackpotsByProductDraw: async _ref5 => {
      let draws = _ref5.draws,
        req = _ref5.req;
      return await fetchJackpotsByProductDraw(draws, getFetchDataFunction(req));
    }
  };
} else {
  currencyInMillions = svs.utils.format.CurrencyInMillions;
  productMapping = svs.numbergames.productMapping;
  drawgamesApiCaller = svs.tur.apiCaller.drawgames;
  const fetchData = async (fetchFunction, fetchParams) => {
    var _resp$response;
    const resp = await fetchFunction(fetchParams);
    return (_resp$response = resp.response) !== null && _resp$response !== void 0 ? _resp$response : resp;
  };
  svs.numbergames.jackpot.fetchJackpots = async draws => await fetchJackpots(draws, fetchData);
  svs.numbergames.jackpot.fetchJackpotsByProductDraw = async draws => await fetchJackpotsByProductDraw(draws, fetchData);
}

 })(window);